import { Model } from '../../model/model';
import { FEATURE_PERIMETER } from '../../model/enums';
import { Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { IWizItemRenderer, TreeItemWrapper, WizTree } from '@wizeoo/akm-component-lib';
import { UserApplicationVO } from '../../vo/user/user-app.vo';
import { BusinessUnitVO } from '../../vo/core/business-unit.vo';
import { VisionVO } from '@wizeoo/akm-compute-lib';

@Component({
  selector: 'user-app-renderer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <wiz-hgroup height="100%" [verticalAlign]="'center'">
    <wiz-image [sourceObservable]="getIcon()" height="20px" width="20px"></wiz-image>
    <wiz-label [wizLabel]="getName()"></wiz-label>
  </wiz-hgroup>
`
})
export class UserAppRenderer implements IWizItemRenderer<TreeItemWrapper<UserApplicationVO>, UserApplicationVO> {

  context: TreeItemWrapper<UserApplicationVO>;
  owner: WizTree<UserApplicationVO>;

  _data: UserApplicationVO;

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) { }

  public set data(value: UserApplicationVO) {
    this._data = value;
    this.cdref.markForCheck();
  }

  public get model(): Model {
    return this._data.model;
  }

  public get data(): UserApplicationVO {
    return this._data;
  }

  /**
   * récupération du nom de la bu
   * @returns nom de la bu
   */
  public getName(): string {
    return this.data.trsLabel;
  }

  /**
   * L'icone associé
   */
  getIcon(): any {
    if (this.data.perimeter === FEATURE_PERIMETER.DOM) {
      return this.model.businessUnitEngine.currentDomain.iconOrDie;
    } else if (this.data.perimeter === FEATURE_PERIMETER.BU) {
      const bu: BusinessUnitVO = this.model.businessUnitEngine.getByBusinessUnitCode(this.data.domain, this.data.businessUnitCode);
      return bu.iconOrDie;
    } else {
      const vision: VisionVO = this.model.visions.find(vis => vis.domain === this.data.domain &&
                                                                        vis.businessUnitCode === this.data.businessUnitCode &&
                                                                        vis.code === this.data.visionCode);

      if (!!vision) {
        return vision.iconOrDie;
      }
    }
  }
}
